<template>
  <div class="col-lg-12 col-md-12">
    <card>
      <div v-if="noAuthProfiles.length > 0">
        <h5 slot="header">Activate Instagram Profiles</h5>
        <hr />
        <div class="row" v-for="pendingProfile in noAuthProfiles" :key="pendingProfile.instagramId">
          <div class="col" style="width:250px;">@{{pendingProfile.instagramProfile}}</div>
          <div class="col">
            <facebook-login
              class="button"
              appId="559044168226179"
              @login="onLogin"
              @logout="onLogout"
              @get-initial-status="getUserData"
              @sdk-loaded="sdkLoaded"
              logoutLabel="Log out"
              :loginOptions="permissions"
            ></facebook-login>
          </div>
        </div>
      </div>

      <div v-else-if="relatedProfiles!=null">
        <h5 slot="header">Active Instagram Profiles</h5>
        <hr />
        <div
          class="row"
          v-for="relatedProfile in relatedProfiles"
          :key="relatedProfile.instagramId"
        >
          <div
            class="col-md-3"
            style="margin-left:15px; padding: 10px;"
          >@{{relatedProfile.instagramProfile}}</div>
          <div class="col">
            <p-button
              round
              outline
              type="info"
              size="sm"
              @click="fbProfileDelete(relatedProfile.instagramProfile)"
            >unlink profile</p-button>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import firebase from "firebase";
import facebookLogin from "facebook-login-vuejs";
import VFacebookLogin from "vue-facebook-login-component";
import { mapGetters, mapActions } from "vuex";
import { Card, Checkbox, Button } from "src/components/UIComponents";

import {
  userLoadApi,
  userRelatedProfilesApi,
  fbGraphCreateProfile,
  fbGraphInstagramCheck,
  fbGraphProfileDelete
} from "@/config/appSettings";

import axios from "axios";
import store from "@/store/index.js";

export default {
  name: "FbAuth",
  components: {
    facebookLogin,
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    VFacebookLogin
    /*TopNavbar,
    ContentFooter,
    UserMenu*/
  },
  data() {
    return {
      isConnected: false,
      fbName: "",
      fbEmail: "",
      personalId: "",
      fbPicture: "",
      FB: undefined,
      isTeam: null,
      isClient: null,
      isInfluencer: null,
      profileDetails: null,
      auth: null,
      relatedProfiles: null,
      noAuthProfiles: [],
      relatedProfileList: null,
      instagramLinked: false,
      FB: {},
      model: {},
      scope: {},
      permissions: {
        scope: null
      }
    };
  },
  computed: {
    ...mapGetters(["profileStore", "relatedProfileStore"])
  },
  methods: {
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
      //console.log("THIS SCOPE", this.scope);
    },

    async getUserData() {
      let self = this;
      try {
        this.FB.api("/me", "GET", { fields: "id,name,email,picture" }, user => {
          //console.log("HERE IS THE USER:", user);
          self.personalId = user.id;
          self.fbEmail = user.email;
          self.fbName = user.name;
          self.fbPicture = user.picture.data.url;
          self.checkLogin();
        });
      } catch (err) {
        console.log("ERROR:", err);
      }
    },
    async checkLogin() {
      let self = this;
      await this.FB.getLoginStatus(function(response) {
        //console.log("RESPONSE:", response);
        if (response.status === "connected") {
          let fbProfileInfo = {};
          fbProfileInfo.usertoken = self.auth;
          fbProfileInfo.facebook = self.personalId;
          fbProfileInfo.token = response.authResponse.accessToken;
          fbProfileInfo.name = self.fbName;
          fbProfileInfo.email = self.fbEmail;
          fbProfileInfo.pic = self.fbPicture;

          console.log("FB PROFILE SENDING...", fbProfileInfo);

          axios
            .post(fbGraphCreateProfile, fbProfileInfo)
            .then(fbProfileResponse => {
              console.log(fbProfileResponse.data);
              if (fbProfileResponse.data.success == true) {
                self.$router.go(0);
              }
            });
        }
      });
    },
    async sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData();
    },
    async onLogin() {
      this.isConnected = true;
      this.getUserData();
    },
    async onLogout() {
      this.isConnected = false;
    },
    async setProfileType() {
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (this.relatedProfileStore == null) {
          let relatedProfileResponse = await axios.get(
            `${userRelatedProfilesApi}/?usertoken=${this.auth}`
          );
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async checkNoAuthProfiles() {
      try {
        //console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (this.relatedProfileStore !== null) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (this.relatedProfiles !== null) {
          this.relatedProfileList = this.relatedProfiles.map(x => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageData() {
      try {
      } catch (err) {}
      await this.setProfileType();
      //this.getRelatedProfiles();
      if (this.isClient == true || this.isInfluencer == true) {
        if (this.isClient == true) {
          this.permissions.scope =
            "instagram_basic,instagram_manage_comments,instagram_manage_insights,pages_show_list";
        }
        if (this.isInfluencer == true) {
          this.permissions.scope =
            "instagram_basic,instagram_manage_insights,pages_show_list";
        }
        //console.log("LOADING FUNCTIONS");
        await this.getRelatedProfiles();
        await this.checkNoAuthProfiles();
        return;
      }
      //console.log("NO PROFILE TYPES...");
    },
    async fbProfileDelete(instagram) {
      try {
        let deleteProfile = {};
        deleteProfile.usertoken = this.auth;
        deleteProfile.instagram = instagram;
        let deleteProfileResponse = await axios.post(
          fbGraphProfileDelete,
          deleteProfile
        );
        //console.log("DELETE PROFILE RESPONSE:", deleteProfileResponse.data);
        if (deleteProfileResponse.data.success == true) {
          this.$router.go(0);
        }
      } catch (err) {
        console.log("THERE WAS AN ERR: ", err);
      }
    }
  },
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageData();
  }
};
</script>
<style scoped>
</style>